import React, { Component } from 'react'
import { Modal, Row, Col } from "react-bootstrap";
import moment from "moment";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";

const CREATE_MATERIALS_STORE_DETAILS = gql`
  mutation($params:CreateMaterialStoreDetails) {
    createMaterialStoreDetails(params:$params)
  }
`;

const GET_MATERIALS = gql`
  query($institute_id:Int,$branch_id:Int,$class_id:Int,$material_type_id:Int){
    getMaterials(institute_id:$institute_id,branch_id:$branch_id,class_id:$class_id,material_type_id:$material_type_id){
      id
      material_name
    }
  }
`;

const GET_MATERIAL_STORE_DETAILS = gql`
  query($institute_id:Int,$branch_id:Int,$class_id:Int,$material_type_id:Int,$date:String){
    getMaterialStoreDetails(institute_id:$institute_id,branch_id:$branch_id,class_id:$class_id,material_type_id:$material_type_id,date:$date){
      quantity
    }
  }
`;

const FIN = {
    label: { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5, display: "block" },
    input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%", height: 44 },
    err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
    section: { background: "#fff", borderRadius: 12, padding: "20px 20px 8px", marginBottom: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
    heading: { fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 14, display: "flex", alignItems: "center", gap: 7 },
    btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "11px 34px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
    btnAddRow: { display: "inline-flex", alignItems: "center", gap: 6, background: "#f5f3ff", color: "#7c3aed", border: "1px solid #ddd6fe", borderRadius: 9, padding: "8px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
};

class MaterialstoreCreationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            branchError: "",
            class: "",
            classError: "",
            materialTypesData: props.getMaterialTypes,
            selectedMaterialType: "",
            materialtypesError: "",
            getClasses: [],
            dataClear: 1,
            loadingSpinner: 0,
            submitted: false,
            currentStep: 1,
            submitError: "",
            is_grouping: true,
            date: new Date().toISOString().slice(0, 10),
            newly_Existing_StoreDetails: [],
            materialDetails: [],
            materialDataSpinner: 0
        };
    }

    classOptionsForBranch = (branchId) => {
        const b = (this.props.branches || []).find(x => String(x.id) === String(branchId));
        const sections = b ? (b.sections || []) : [];
        const classIds = [...new Set(sections.map(s => Number(s.class_id)))];
        return classIds.map(cid => (this.props.getClasses || []).find(c => c.id === cid)).filter(Boolean).map(c => ({ value: c.id, label: c.class }));
    };

    addRow = () => {
        const array = this.state.newly_Existing_StoreDetails;
        array.push({ id: null, material_id: null, material_name: "", material_count: "", material_received_date: "", materialNameError: "", quantity_error: "", material_received_date_error: "" });
        this.setState({ newly_Existing_StoreDetails: array });
    }

    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "materialtypes") {
            if (value != "0") {
                const grouping = this.state.materialTypesData.find((item) => item.id == value).is_grouping == 1;
                this.setState({
                    branch: "", branchError: "", class: "", classError: "",
                    selectedMaterialType: value, materialtypesError: "",
                    getClasses: [], loadingSpinner: 0, submitted: false, submitError: "",
                    is_grouping: grouping, newly_Existing_StoreDetails: [], materialDetails: [], materialDataSpinner: 0
                });
            } else {
                this.setState({
                    branch: "", branchError: "", class: "", classError: "",
                    selectedMaterialType: "", materialtypesError: "",
                    getClasses: [], loadingSpinner: 0, submitted: false, submitError: "",
                    is_grouping: true, newly_Existing_StoreDetails: [], materialDetails: [], materialDataSpinner: 0
                });
            }
        }

        if (name == "branch") {
            if (value != "0") {
                this.setState({
                    branch: value, branchError: "", class: "", classError: "",
                    getClasses: this.classOptionsForBranch(value),
                    loadingSpinner: 0, submitted: false, submitError: "",
                    newly_Existing_StoreDetails: [], materialDetails: [], materialDataSpinner: 0
                });
                if (!this.state.is_grouping) {
                    this.getMaterials(value, "");
                    if (this.state.selectedMaterialType != "") {
                        this.getMaterialStoreDetails1(value, "", this.state.date);
                    }
                }
            } else {
                this.setState({
                    branch: "", branchError: "", class: "", classError: "",
                    getClasses: [], loadingSpinner: 0, submitted: false, submitError: "",
                    newly_Existing_StoreDetails: [], materialDetails: [], materialDataSpinner: 0
                });
            }
        }

        if (name == "class") {
            if (value != "0") {
                this.setState({
                    branchError: "", class: value, classError: "",
                    loadingSpinner: 0, submitted: false, submitError: "",
                    newly_Existing_StoreDetails: [], materialDetails: [], materialDataSpinner: 0
                });
                this.getMaterials(this.state.branch, value);
                this.getMaterialStoreDetails1(this.state.branch, value, this.state.date);
            } else {
                this.setState({
                    branchError: "", class: "", classError: "",
                    loadingSpinner: 0, submitted: false, submitError: "",
                    newly_Existing_StoreDetails: [], materialDetails: [], materialDataSpinner: 0
                });
            }
        }
    }

    getMaterials = async (val1, val2) => {
        const result = await this.props.client.query({
            query: GET_MATERIALS,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val1),
                class_id: parseInt(val2),
                material_type_id: parseInt(this.state.selectedMaterialType)
            },
            fetchPolicy: 'network-only'
        });
        if (result.data.getMaterials.length > 0) {
            this.setState({ materialDetails: result.data.getMaterials });
        }
    }

    getMaterialStoreDetails1 = async (branchValue, classValue, date) => {
        this.setState({ newly_Existing_StoreDetails: [], materialDataSpinner: 1 });
        const result1 = await this.props.client.query({
            query: GET_MATERIAL_STORE_DETAILS,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(branchValue),
                class_id: parseInt(classValue),
                material_type_id: parseInt(this.state.selectedMaterialType),
                date: moment(date).unix().toString(),
            },
            fetchPolicy: 'network-only'
        });

        if (result1.data.getMaterialStoreDetails.length > 0) {
            const data = result1.data.getMaterialStoreDetails;
            const materialData = [];
            data[0].quantity.map((item) => {
                materialData.push({ ...item, materialNameError: "", quantity_error: "", material_received_date_error: "" });
            });
            this.setState({ newly_Existing_StoreDetails: materialData, materialDataSpinner: 0 });
        } else {
            this.setState({
                newly_Existing_StoreDetails: [{ id: null, material_id: "", material_name: "", material_count: "", material_received_date: "", materialNameError: "", quantity_error: "", material_received_date_error: "" }],
                materialDataSpinner: 0
            });
        }
    }

    handleSubmit = () => {
        if (this.state.selectedMaterialType == "" || this.state.selectedMaterialType == "0") {
            this.setState({ materialtypesError: "Please Select Material" }); return;
        }
        if (this.state.branch == "" || this.state.branch == "0") {
            this.setState({ branchError: "Please Select Branch" }); return;
        }
        if (this.state.is_grouping && (this.state.class == "" || this.state.class == "0")) {
            this.setState({ classError: "Please Select Class" }); return;
        }

        let stopExecuting = false;
        this.state.newly_Existing_StoreDetails.some((obj, i) => {
            const errorUpdate = this.state.newly_Existing_StoreDetails;
            if (obj.material_name == "" || obj.material_name == undefined) {
                errorUpdate[i] = { ...obj, materialNameError: "Please Select Material Name" };
                this.setState({ newly_Existing_StoreDetails: errorUpdate }); stopExecuting = true; return true;
            }
            if (obj.material_count == "" || obj.material_count == undefined) {
                errorUpdate[i] = { ...obj, quantity_error: "Please Enter Quantity" };
                this.setState({ newly_Existing_StoreDetails: errorUpdate }); stopExecuting = true; return true;
            }
            if (obj.material_received_date == "" || obj.material_received_date == undefined) {
                errorUpdate[i] = { ...obj, material_received_date_error: "Please Select Received Date" };
                this.setState({ newly_Existing_StoreDetails: errorUpdate }); stopExecuting = true; return true;
            }
        });
        if (stopExecuting) return;

        const array = [];
        if (this.state.newly_Existing_StoreDetails.length > 0) {
            this.state.newly_Existing_StoreDetails.map((item) => {
                array.push({ id: item.id, material_id: item.material_id, material_name: item.material_name, material_count: item.material_count, material_received_date: item.material_received_date });
            });
        }

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch),
            class_id: parseInt(this.state.class),
            material_type_id: parseInt(this.state.selectedMaterialType),
            quantity: array,
            received_by: parseInt(Cookies.get("id")),
            inserted_by: parseInt(Cookies.get("id")),
        };

        this.setState({ loadingSpinner: 1 });
        this.createMaterialStoreDetails(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
        });
    }

    createMaterialStoreDetails = async (params) => {
        await this.props.createMaterialStoreDetails({
            variables: { params },
            update: (store, { data }) => {
                if (data.createMaterialStoreDetails) {
                    this.setState({ loadingSpinner: 0, currentStep: 5 });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }
        });
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch: "", branchError: "", class: "", classError: "",
                materialTypesData: this.props.getMaterialTypes, selectedMaterialType: "", materialtypesError: "",
                getClasses: [], dataClear: 1, loadingSpinner: 0, submitted: false, currentStep: 1, submitError: "",
                is_grouping: true, date: new Date().toISOString().slice(0, 10),
                newly_Existing_StoreDetails: [], materialDetails: [], materialDataSpinner: 0
            });
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 });
        }
    }

    handleChange = (a, i) => {
        const name = a.target.name;
        const value = a.target.value;
        const array = [];
        this.state.newly_Existing_StoreDetails.map((item, index) => {
            if (i == index) {
                let material_id = item.material_id;
                let material_count = item.material_count;
                let material_received_date = item.material_received_date;
                let material_name = item.material_name;
                if (name == "materialName") {
                    if (value != "") {
                        const filteredMaterials = this.state.materialDetails.filter((a) => a.id == value);
                        material_id = value;
                        material_name = filteredMaterials[0].material_name;
                        material_count = "";
                        material_received_date = "";
                    } else {
                        material_id = null; material_name = ""; material_count = ""; material_received_date = "";
                    }
                } else if (name == "quantity") {
                    material_count = value;
                } else {
                    material_received_date = value != "" ? moment(value).unix() : "";
                }
                array.push({ ...item, material_id, material_name, material_count, materialNameError: "", quantity_error: "", material_received_date_error: "", material_received_date });
            } else {
                array.push({ ...item });
            }
        });
        this.setState({ newly_Existing_StoreDetails: array });
    }

    selectDate = (e) => {
        const selectedDate = e.target.value;
        this.setState({ date: selectedDate, newly_Existing_StoreDetails: [] });
        if (this.state.branch != "" && this.state.is_grouping && this.state.class != "") {
            this.getMaterialStoreDetails1(this.state.branch, this.state.class, selectedDate);
        } else if (this.state.branch != "" && !this.state.is_grouping) {
            this.getMaterialStoreDetails1(this.state.branch, "", selectedDate);
        }
    }

    render() {
        return (
            <Modal {...this.props} size="lg" aria-labelledby="material-store-update-modal">
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", display: "flex", alignItems: "center", gap: 9 }}>
                        <i className="fal fa-warehouse" style={{ color: "#7c3aed" }} />Material Details Update
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#F8FAFC", padding: "24px 24px 16px" }}>
                    <div style={FIN.section}>
                        <p style={FIN.heading}><i className="fal fa-filter" />Select Target</p>
                        <Row>
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <label style={FIN.label}>Material Type</label>
                                <select style={FIN.input} name="materialtypes" onChange={this.handleInputChange} value={this.state.selectedMaterialType}>
                                    <option value="0">--Select Material--</option>
                                    {this.state.materialTypesData.map(item1 => (
                                        <option key={item1.id} value={item1.id}>{item1.material_type}</option>
                                    ))}
                                </select>
                                {this.state.materialtypesError ? <span style={FIN.err}>{this.state.materialtypesError}</span> : null}
                            </Col>
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <label style={FIN.label}>Branch</label>
                                <select style={FIN.input} name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                    <option value="0">--Select Branch--</option>
                                    {(this.props.branches || []).map(b => (
                                        <option key={b.id} value={b.id}>{b.branch_name}</option>
                                    ))}
                                </select>
                                {this.state.branchError ? <span style={FIN.err}>{this.state.branchError}</span> : null}
                            </Col>
                            {this.state.is_grouping ? (
                                <Col lg={3} md={6} sm={12} className="mb-3">
                                    <label style={FIN.label}>Class</label>
                                    <select style={FIN.input} name="class" onChange={this.handleInputChange} value={this.state.class}>
                                        <option value="0">--Select Class--</option>
                                        {this.state.getClasses.map(c => (
                                            <option key={c.value} value={c.value}>{c.label}</option>
                                        ))}
                                    </select>
                                    {this.state.classError ? <span style={FIN.err}>{this.state.classError}</span> : null}
                                </Col>
                            ) : null}
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <label style={FIN.label}>Select Date</label>
                                <input type="date" name="date" style={FIN.input} value={this.state.date} onChange={(e) => this.selectDate(e)} />
                            </Col>
                        </Row>
                    </div>

                    {this.state.materialDataSpinner == 1 ? (
                        <div style={{ textAlign: "center", padding: "20px 0" }}>
                            <span className="spinner-border" style={{ color: "#7c3aed" }} />
                        </div>
                    ) : null}

                    {this.state.newly_Existing_StoreDetails.length > 0 ? (
                        <div style={FIN.section}>
                            <p style={FIN.heading}><i className="fal fa-boxes" />Quantities</p>
                            <Row>
                                {this.state.newly_Existing_StoreDetails.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Col sm={4} className="mb-3">
                                            <label style={FIN.label}>Material Name</label>
                                            <select style={FIN.input} value={item.material_id} onChange={(e) => this.handleChange(e, index)} name="materialName">
                                                <option value="">--Material Details--</option>
                                                {this.state.materialDetails.map((m) => (
                                                    <option key={m.id} value={m.id}>{m.material_name}</option>
                                                ))}
                                            </select>
                                            {item.materialNameError ? <span style={FIN.err}>{item.materialNameError}</span> : null}
                                        </Col>
                                        <Col sm={4} className="mb-3">
                                            <label style={FIN.label}>Enter Quantity</label>
                                            <input type="number" value={item.material_count} onChange={(e) => this.handleChange(e, index)} name="quantity" style={FIN.input} placeholder="Enter Quantity" />
                                            {item.quantity_error ? <span style={FIN.err}>{item.quantity_error}</span> : null}
                                        </Col>
                                        <Col sm={4} className="mb-3">
                                            <label style={FIN.label}>Received Date</label>
                                            <input type="datetime-local" name="material_received_date" style={FIN.input} value={item.material_received_date != "" ? moment.unix(item.material_received_date).format('YYYY-MM-DDTHH:mm') : ""} onChange={(e) => this.handleChange(e, index)} />
                                            {item.material_received_date_error ? <span style={FIN.err}>{item.material_received_date_error}</span> : null}
                                        </Col>
                                    </React.Fragment>
                                ))}
                            </Row>
                            <button type="button" onClick={this.addRow} style={FIN.btnAddRow}>
                                <i className="fas fa-plus" /> Add Row
                            </button>
                        </div>
                    ) : null}
                </Modal.Body>
                <Modal.Footer style={{ borderTop: "none", justifyContent: "center", flexDirection: "column" }}>
                    {this.state.currentStep == 5 ? (
                        <p style={{ color: "#059669", fontWeight: 600, marginBottom: 10 }}>Created Successfully</p>
                    ) : this.state.submitError ? (
                        <p style={{ color: "#dc2626", marginBottom: 10 }}>{this.state.submitError}</p>
                    ) : null}
                    {this.state.newly_Existing_StoreDetails.length > 0 ? (
                        <button type="button" style={FIN.btnPrimary} onClick={() => this.handleSubmit()}>
                            {this.state.loadingSpinner == 1 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-save" />}
                            Create
                        </button>
                    ) : null}
                </Modal.Footer>
            </Modal>
        )
    }
}
export default withRouter(withApollo(compose(
    graphql(CREATE_MATERIALS_STORE_DETAILS, {
        name: "createMaterialStoreDetails"
    }),
)(MaterialstoreCreationModal)));
